import { SectionLoader } from '@/shared/components/section-loader';

export const TrackerPersonalLoading = () => {
  return <SectionLoader />;
};
